import axiosInstance from '../../api/axios';
import { INotificationCardNotification } from '../../components/organism/NotificationCard';

export interface IGetNotificationsParams {
  page: number;
  limit?: number;
}

export const getNotifications = async ({
  page,
  limit = 5,
}: IGetNotificationsParams): Promise<INotificationCardNotification[]> => {
  try {
    const response = await axiosInstance.get(
      `/newtifications?page=${page}&limit=${limit}`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
};

export const markSeenNotifications = async (): Promise<
  INotificationCardNotification[]
> => {
  try {
    const response = await axiosInstance.get(`/newtifications/seen`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
};
